<template>
  <div>
    <data-table ref="dataTable" :option="option" class="body-table">
      <a-button
        type="link"
        size="small"
        slot="rowAction"
        slot-scope="text, record"
        @click="onDetail(record)"
        >详情</a-button
      >
    </data-table>
    <a-modal
      centered
      v-model="visible.detailModal"
      width="90%"
      :destroyOnClose="true"
      :maskClosable="false"
      class="custom-modal"
      @cancel="onCancleDetail"
    >
      <Detail
        :Idkey="idkey"
        :orderNo="customerCode"
        ref="detail"
        @disabledWriteOff="onDisabledWriteOff"
        @getUnWriteOffAmount="getUnWriteOffAmount"
        @loadData="loadDetailData"
        @getCheckedRows="getCheckedRows"
      />
      <template slot="footer">
        <span class="total-amount"
          >未核销金额总计：<span>&yen;{{ unWriteOffAmount }}</span></span
        >
        <a-button type="primary" @click="writeOff" :disabled="disabled">
          核销
        </a-button>
      </template>
    </a-modal>
    <WriteOff
      ref="writeOff"
      :guestId="idkey"
      :orderNo="customerCode"
      @reloadDetail="onReloadDetail"
    />
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import Detail from "./Detail.vue";
import WriteOff from "./WriteOff.vue";
import { cache } from "@/utils/common";
import calc from "@/utils/calc";
export default {
  name: "arList",
  components: {
    DataTable,
    Detail,
    WriteOff
  },
  data() {
    return {
      visible: {
        detailModal: false
      },
      idkey: "", //行id
      customerCode: "",
      disabled: false, //是否禁用核销按钮
      onAccount: true, //是否禁用挂账按钮
      unWriteOffAmount: 0,
      checkedRows: []
    };
  },
  created() {
    this.loadtable();
    const relatedOrderNo = cache.get("bill_relatedOrder");
    const id = this.$route.query.id;
    this.$nextTick(() => {
      if (relatedOrderNo) {
        this.$refs.dataTable.headSearchFormData = {
          Name: relatedOrderNo
        };
        this.$refs.dataTable.onHeadSearchSubmit({
          Name: relatedOrderNo
        });
        this.onDetail({
          Id: id,
          Code: relatedOrderNo
        });
        cache.remove("bill_relatedOrder");
      } else {
        this.$refs.dataTable.headSearch();
      }
    });
  },
  methods: {
    loadtable() {
      this.option = {
        headSearch: {
          colnum: 2,
          width: 750,
          content: [
            {
              label: "类别",
              type: "select",
              name: "CustomerTypeId", //字段
              api: "Common_GetSelect",
              param: {
                Types: "customertypecontainsgroup" //"CustomerType"
              },
              dataField: "Data.customertypecontainsgroup", //"Data.CustomerType" //字段名
              onChange: () => {
                this.$nextTick(() => {
                  this.$refs.dataTable.headSearch();
                });
              }
            },
            {
              label: "名称",
              name: "Name",
              props: {
                placeholder: "客户姓名或编码"
              },
              pressEnter: () => {
                this.$refs.dataTable.headSearch();
              }
            }
          ],
          onSubmitBefore: values => {
            return values;
          }
        },
        grid: {
          api: "RecVa_GetPageList",
          autoLoad: false,
          columns: [
            {
              title: "序号",
              width: "5%",
              type: "indexcolumn"
            },
            {
              title: "类别", //列标题
              width: "7%", //宽度
              dataIndex: "CustomerTypeName"
            },
            {
              title: "编号",
              width: "8%",
              dataIndex: "Code"
            },
            {
              title: "名称",
              width: "12%",
              dataIndex: "Name"
            },
            {
              title: "简称",
              width: "8%",
              dataIndex: "ShortName"
            },
            {
              title: "应收金额",
              width: "8%",
              align: "right",
              dataIndex: "Amount"
            },
            {
              title: "应收余额",
              align: "right",
              dataIndex: "UnWriteOffAmount",
              width: "8%"
            },
            {
              title: "联系人",
              dataIndex: "Contacts",
              width: "8%"
            },
            {
              title: "联系人电话",
              dataIndex: "ContractNo",
              width: "10%"
            },
            {
              title: "协议",
              dataIndex: "IsAgreement",
              width: "8%"
            },
            {
              title: "状态",
              dataIndex: "IsValid",
              width: "5%"
            },
            {
              title: "有效日期",
              dataIndex: "EndTime",
              width: "8%"
            },
            {
              title: "操作",
              dataIndex: "Id",
              scopedSlots: { customRender: "rowAction" }
            }
          ]
        }
      };
    },
    getCheckedRows(checkedRows) {
      this.checkedRows = checkedRows;
    },
    //打开核销操作
    writeOff() {
      if (!(this.checkedRows && this.checkedRows.length)) {
        this.$message.info("请您至少选择一条数据");
        return;
      }
      this.$refs.writeOff.show(this.checkedRows);
    },
    //打开挂账操作
    accountOn() {
      // let row = this.$refs.detail.getSelected();
      // if (rows.length <= 0) {
      //   this.$message.info("请您至少选择一条数据");
      //   return;
      // }
      // OnAccountModal({
      //   ReceivableId: rows[0].Id,
      //   update: () => {
      //     this.onReloadDetail();
      //   }
      // });
    },
    //禁用核销按钮
    onDisabledWriteOff(value, value2) {
      this.disabled = value;
      this.onAccount = value2;
    },
    //打开应收详情
    onDetail(record) {
      this.disabled = false;
      this.checkedRows = [];
      this.idkey = record.Id;
      this.customerCode = record.Code;
      this.unWriteOffAmount = record.UnWriteOffAmount;
      this.visible.detailModal = true;
    },
    onCancleDetail() {
      this.visible.detailModal = false;
      this.$refs.dataTable.headSearch();
    },
    onReloadDetail() {
      this.$refs.detail.reload();
      this.checkedRows = [];
    },
    getUnWriteOffAmount() {
      // this.unWriteOffAmount = value;
    },
    loadDetailData(data) {
      let total = 0;
      if (data && data.length) {
        data.forEach(el => {
          // total = accAdd(total, el.UnWriteOffAmount);
          total = calc(total)
            .add(el.UnWriteOffAmount)
            .number(2);
        });
      }
      this.unWriteOffAmount = total;
    }
  }
};
</script>

<style lang="less" scoped>
.body-table {
  /deep/ .ant-table-thead {
    /deep/ .ant-table-align-right {
      div {
        text-align: center;
      }
    }
  }
  /deep/ .head {
    /deep/ .head-search-box {
      /deep/ .ant-form-item-label {
        width: 60px;
      }
    }
  }
  /deep/ .ant-table-tbody {
    /deep/ tr {
      div {
        .ant-divider {
          display: none;
        }
        button:nth-of-type(2) {
          display: none;
        }
      }
    }
  }
}
.ant-modal-close-x {
  line-height: 36px !important;
}
.total-amount {
  margin-right: 200px;
  color: #333;
  & > span {
    font-size: 18px;
    color: #f00;
  }
}
</style>
